import { Requests, Methods } from 'utils/requests';
import { ApiError } from './ApiError';

export const requests = new Requests();

export const get = (url, params = null) => requests.get(url, params);

export const post = (url, data) => requests.post(url, data);

export const patch = (url, data) => requests.patch(url, data);

export const remove = (url, data) => requests.delete(url, data);

export const upload = (url, data, file) => requests.upload(url, data, file);

export const checkResponse = (request, pagination = false) =>
    request.then(response => {
        if (response.error) {
            const error = new ApiError(response.error);
            error.id = response.id;
            throw error;
        }
        return typeof response.data !== 'undefined' && !pagination
            ? response.data
            : response;
    });

requests.onRequest(function encodeGetParams(config) {
    if (config.method === Methods.GET) {
        if (typeof config.body === 'object') {
            config.url = encodeUrlParams(config.url, config.body);
            delete config.body;
        }
    }
    return config;
});

requests.onRequest(function addCSRFToken(config) {
    if (config.method !== Methods.GET) {
        config.headers['X-CSRFToken'] = getCsrftoken();
    }
    return config;
});

requests.onRequest(function encodeJsonBody(config) {
    if (config.body instanceof FormData) {
        delete config.headers['Content-Type'];
    } else {
        const serializedMethods = [Methods.POST, Methods.PATCH, Methods.DELETE];
        if (serializedMethods.includes(config.method)) {
            config.body = JSON.stringify(config.body);
            config.headers['Content-Type'] = 'application/json';
        }
    }

    return config;
});

requests.onResponse(function checkRedirection(response) {
    let location = '';
    if (response.redirected && response.url) {
        location = response.url;
    } else if (response.headers) {
        location = response.headers.get('Location');
    }
    if (location) {
        window.location.href = location;
    }
    return response;
});

requests.onResponse(function checkAccess(response) {
    if (response.status === 403) {
        window.location.href = '/';
        return Promise.reject(decodeJsonBody);
    }
    return response;
});

requests.onResponse(function checkAuthorized(response) {
    if (response.status === 401) {
        window.location.href = '/auth/logout';
        return Promise.reject(decodeJsonBody);
    }
    return response;
});

requests.onResponse(decodeJsonBody);

function encodeUrlParams(url, params) {
    if (params) {
        let formattedUrl = new URL(window.location.origin + url);
        Object.keys(params).forEach(key =>
            formattedUrl.searchParams.append(key, params[key])
        );
        return url;
    }
}

function getCsrftoken() {
    var cookies = {};
    for (let cookie of document.cookie.split('; ')) {
        let [name, value] = cookie.split('=');
        try {
            cookies[name] = decodeURIComponent(value);
        } catch (e) {}
    }
    return cookies['csrftoken'];
}

function decodeJsonBody(response) {
    if (response.headers && response.headers.get) {
        const fullContentType = response.headers.get('Content-Type');
        if (fullContentType) {
            const contentType = fullContentType.split(';')[0].trim();
            if (contentType === 'application/json') {
                return response.json();
            }
            if (contentType === 'text/html') {
                return response.text();
            }
        }
    }
    return response;
}
